import React, { Fragment } from 'react';
import {
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  Checkbox,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Toggle,
  Preloader,
  Badge,
  Stepper,
  Popover,
} from 'framework7-react';

import {
  PrimaryLogo,
  MerchantSvg,
  BikeSvg,
  WalletSvg,
} from '../components/crumbs';

import moment from 'moment';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStorage, firestoreConnect } from '../HOCs';
import { Doc, DocArray } from '../utils/_classes';
import {
  handleErrors,
  isEmpty,
  toast,
  generateId,
  fetchBanks,
  resolveAccountNumber,
  createTransferRecipient,
  deleteTransferRecipient,
  payStackTransferCharge,
  initiateATransfer,
  sendOneTimePassword,
  verifyOneTimePassword,
  addOrRemoveBank,
} from '../utils/_helpers';

class MerchantWallet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: '',
        which: '',
      },
      // Bank
      addBankButton: 'Upload Bank Details',
      bank: {
        bankName: '',
        accountName: '',
        accountNumber: '',
        sortCode: '',
        bankCode: '',
      },
      banks: [],
      BanksWithIssues: ['Parallex Bank'],

      // Withdrawals
      withdrawalButton: 'Confirm Transaction',
      withdrawalInfo: {
        recipientCode: '',
        amount: 0,
      },
    };
  }

  render() {
    if (!this.props.merchants[this.props.auth.uid]) {
      return (
        <Page>
          <Block className="pattern-banner bg-color-theme">
            <Card style={{ width: '100%', margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0 }}>Become a merchant </h3>
                <Button fill href="/business-registration/1/">
                  Merchant Registration
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: 'center', marginTop: '10vh' }}>
              <MerchantSvg size="300px" />
              <h6>Earn more profit selling online with Easychaw</h6>
            </div>
          </Block>
        </Page>
      );
    }

    if (this.props.merchants[this.props.auth.uid].accountStatus == 'Pending') {
      return (
        <Page>
          <Block className="pattern-banner bg-color-orange">
            <Card style={{ width: '100%', margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0, color: '#ef6c00' }}>
                  Application Pending{' '}
                </h3>
                <Button
                  fill
                  tabLink="#view-message-master"
                  onClick={() =>
                    this.navMessage('account', 'admin', 'account')
                  }>
                  Contact Admin
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: 'center', marginTop: '10vh' }}>
              <img src="static/relax.svg" style={{ width: '300px' }} />
              <h6>
                Please contact Admin after 24 hours <br /> if account is still
                pending.
              </h6>
            </div>
          </Block>
        </Page>
      );
    }

    if (
      this.props.merchants[this.props.auth.uid].accountStatus == 'Suspended'
    ) {
      return (
        <Page>
          <Block className="pattern-banner bg-color-pink">
            <Card style={{ width: '100%', margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0, color: '#E02020' }}>
                  Account Suspended{' '}
                </h3>
                <Button
                  className="button-fill-red"
                  tabLink="#view-message-master"
                  onClick={() =>
                    this.navMessage('account', 'admin', 'account')
                  }>
                  Contact Admin
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: 'center', marginTop: '10vh' }}>
              <img src="static/cancel.svg" style={{ width: '300px' }} />
              <h6>
                Access Denied <br /> Please contact admin
              </h6>
            </div>
          </Block>
        </Page>
      );
    }

    return (
      <Page>
        <Block>
          <Row>
            <Col width="100" className="xsmall-40">
              <div
                style={{
                  width: '103%',
                  paddingTop: '9px',
                  marginLeft: '-6px',
                  position: 'relative',
                }}>
                <WalletSvg id="merchantcard" title="Merchant Wallet" />
                {this.props.wallets &&
                this.props.wallets[
                  this.props.merchants[this.props.auth.uid].walletId
                ] ? (
                  <span className="walletBalance">
                    {new Intl.NumberFormat('en-GB', {
                      style: 'currency',
                      currency: 'NGN',
                    }).format(
                      Number(
                        this.props.wallets[
                          this.props.merchants[this.props.auth.uid].walletId
                        ].walletBalance
                      )
                    )}
                  </span>
                ) : (
                  <span className="walletBalance">NGN 0.00</span>
                )}
                <em className="walletBalanceSubText">Wallet Balance</em>
              </div>
            </Col>

            <Col width="100" className="xsmall-60">
              {/* [Card-1]  Bank Details*/}
              <Card
                style={{
                  width: '100%',
                  marginLeft: '0px',
                  margin: '10pt auto auto',
                }}
                inner
                accordionList
                className="data-table data-table-init">
                <AccordionItem>
                  <CardHeader>
                    <div className="data-table-title">Bank Details</div>
                    <AccordionToggle>
                      <Button outline iconF7="arrowtriangle_down_fill"></Button>
                    </AccordionToggle>
                  </CardHeader>

                  <AccordionContent>
                    <CardContent padding={false}>
                      {this.props.loadingDoc && !this.props.wallets ? (
                        <Block className="text-align-center">
                          <Preloader></Preloader>
                        </Block>
                      ) : !this.props.loadingDoc &&
                        (!this.props.wallets ||
                          !this.props.wallets[
                            this.props.merchants[this.props.auth.uid].walletId
                          ]) ? (
                        <Block className="pab">
                          <Row>
                            <Col>
                              <p>
                                You don't have a wallet! Please add bank
                                details.
                              </p>
                            </Col>
                          </Row>
                        </Block>
                      ) : (
                        <>
                          {this.props.wallets[
                            this.props.merchants[this.props.auth.uid].walletId
                          ] &&
                          this.props.wallets[
                            this.props.merchants[this.props.auth.uid].walletId
                          ].bankDetails.length > 0 ? (
                            <table>
                              <thead>
                                <tr>
                                  <th>
                                    <span className="table-head-label">
                                      SNo.
                                    </span>
                                  </th>
                                  <th>
                                    <span className="table-head-label">
                                      Business Bank Account Name
                                    </span>
                                  </th>
                                  <th>
                                    <span className="table-head-label">
                                      Account Number
                                    </span>
                                  </th>
                                  <th>
                                    <span className="table-head-label">
                                      Bank Name
                                    </span>
                                  </th>
                                  <th>
                                    <span className="table-head-label">
                                      Action
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.wallets[
                                  this.props.merchants[this.props.auth.uid]
                                    .walletId
                                ].bankDetails.map(
                                  (
                                    {
                                      bankName,
                                      accountName,
                                      accountNumber,
                                      recipientCode,
                                    },
                                    i
                                  ) => (
                                    <tr key={i}>
                                      <td> {i + 1} </td>
                                      <td>
                                        <div>{accountName}</div>
                                      </td>
                                      <td>{accountNumber}</td>
                                      <td>
                                        <div>{bankName}</div>
                                      </td>
                                      <td>
                                        <Button
                                          fill
                                          style={{
                                            backgroundImage:
                                              'linear-gradient(#FF6969, #E02020)',
                                            color: 'white',
                                            maxWidth: '41px',
                                          }}
                                          iconF7="trash_circle"
                                          onClick={() =>
                                            this.deleteBank(i, recipientCode)
                                          }></Button>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          ) : (
                            <Block className="block-info">
                              <Row>
                                <Col>
                                  <p>No bank details found</p>
                                </Col>
                              </Row>
                            </Block>
                          )}
                        </>
                      )}
                    </CardContent>

                    <CardFooter className="easyPrintText">
                      <pre className="round">
                        <small>For withdrawal use</small>
                      </pre>
                      <Button
                        round
                        fill
                        style={{
                          width: '40%',
                          marginLeft: '10px',
                        }}
                        onClick={() => {
                          this.$f7.preloader.show();
                          fetchBanks((error, banks) => {
                            if (error) {
                              toast(this.$f7.toast, {
                                text: 'Something went wrong. Try again',
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                              return this.$f7.preloader.hide();
                            }
                            this.setState({
                              ...this.state,
                              banks,
                              popupOpened: true,
                              popupDataChanged: true,
                              popupData: {
                                title: 'Add Bank Details',
                                which: 'add-bank',
                              },
                            });
                            this.$f7.preloader.hide();
                          });
                        }}>
                        Add Account
                      </Button>
                    </CardFooter>
                  </AccordionContent>
                </AccordionItem>
              </Card>

              {/* [Card-2]  Withdrawal*/}
              {this.props.wallets &&
              this.props.wallets[
                this.props.merchants[this.props.auth.uid].walletId
              ] ? (
                this.props.wallets[
                  this.props.merchants[this.props.auth.uid].walletId
                ].ban ? (
                  <Card style={{ margin: '17pt auto' }} inner accordionList>
                    <AccordionItem>
                      <CardHeader>
                        Withdrawal
                        <AccordionToggle>
                          <Button
                            outline
                            iconF7="arrowtriangle_down_fill"></Button>
                        </AccordionToggle>
                      </CardHeader>

                      <AccordionContent>
                        <CardContent padding={false}>
                          <Block className="pab">
                            <Row>
                              <Col>
                                <p>Access Revoked &nbsp;&nbsp;&nbsp;</p>
                              </Col>
                              <Col>
                                <Link
                                  className="pal"
                                  tabLink="#view-message-master"
                                  onClick={() =>
                                    this.navMessage(
                                      'account',
                                      'admin',
                                      'account'
                                    )
                                  }>
                                  Contact Admin
                                </Link>
                              </Col>
                            </Row>

                            <Row className="pat">
                              <Col>
                                <p style={{ margin: '0', color: ' #9E9E9E' }}>
                                  Suspicious activity detected on your account.
                                  Your acccount has been banned from making a
                                  withdrawal please contact admin.
                                </p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      </AccordionContent>
                    </AccordionItem>
                  </Card>
                ) : (
                  <Card style={{ margin: '17pt auto' }} inner accordionList>
                    <AccordionItem>
                      <CardHeader>
                        Withdrawal
                        <AccordionToggle>
                          <Button
                            outline
                            iconF7="arrowtriangle_down_fill"></Button>
                        </AccordionToggle>
                      </CardHeader>

                      <AccordionContent>
                        <CardContent>
                          <List noHairlinesMd>
                            {this.props.wallets[
                              this.props.merchants[this.props.auth.uid].walletId
                            ].pendingWithdrawal &&
                            this.props.wallets[
                              this.props.merchants[this.props.auth.uid].walletId
                            ].pendingWithdrawal.length > 0
                              ? this.props.wallets[
                                  this.props.merchants[this.props.auth.uid]
                                    .walletId
                                ].pendingWithdrawal.map((pw, i) => (
                                  <ListItem
                                    key={i}
                                    header="Pending Withdrawal"
                                    title={`#${pw.amount / 100}`}
                                    footer={
                                      pw.status ? 'Processing' : 'Failed'
                                    }>
                                    <Button
                                      round
                                      fill
                                      slot="after-title"
                                      disabled={pw.status}
                                      onClick={() => this.withdrawalRetry(pw)}
                                      className="button button-fill-blue"
                                      style={{
                                        minWidth: '20%',
                                      }}>
                                      Retry
                                    </Button>
                                  </ListItem>
                                ))
                              : null}
                            <ListItem title="Transfer charge">
                              <small slot="after">
                                {`NGN${payStackTransferCharge(
                                  this.state.withdrawalInfo.amount
                                )}`}
                              </small>
                              <Icon f7="creditcard" slot="media" />
                            </ListItem>
                            <ListInput
                              label="Bank account"
                              type="select"
                              name="account"
                              placeholder="Select account"
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  withdrawalInfo: {
                                    ...this.state.withdrawalInfo,
                                    recipientCode: e.target.value,
                                  },
                                })
                              }
                              style={{ paddingLeft: 0 }}>
                              <Icon f7="briefcase" slot="media" />
                              <option></option>
                              {this.props.wallets &&
                                this.props.wallets[
                                  this.props.merchants[this.props.auth.uid]
                                    .walletId
                                ] &&
                                this.props.wallets[
                                  this.props.merchants[this.props.auth.uid]
                                    .walletId
                                ].bankDetails.map(
                                  (
                                    { accountName, bankName, recipientCode },
                                    i
                                  ) => (
                                    <Fragment key={i}>
                                      <option value={recipientCode}>
                                        {accountName} - {bankName}
                                      </option>
                                    </Fragment>
                                  )
                                )}
                            </ListInput>

                            <ListInput
                              label="Amount to withdraw"
                              type="number"
                              min="1000"
                              placeholder="Minimum withdrawal is NGN1,000"
                              info="Minimum withdrawal is NGN1,000"
                              required
                              clearButton
                              value={this.state.withdrawalInfo.amount}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  withdrawalInfo: {
                                    ...this.state.withdrawalInfo,
                                    amount: e.target.value,
                                  },
                                })
                              }
                              style={{ paddingLeft: 0 }}>
                              <Icon f7="creditcard_fill" slot="media" />
                            </ListInput>
                          </List>
                        </CardContent>
                        <CardFooter>
                          <small>&nbsp;</small>
                          <Button
                            round
                            fill
                            disabled={
                              this.state.withdrawalButton !==
                              'Confirm Transaction'
                            }
                            onClick={this.initiateTransfer.bind(this)}
                            className="button button-fill-blue"
                            style={{
                              minWidth: '40%',
                            }}>
                            {this.state.withdrawalButton ===
                            'Confirm Transaction' ? (
                              this.state.withdrawalButton
                            ) : (
                              <Preloader></Preloader>
                            )}
                          </Button>
                        </CardFooter>
                      </AccordionContent>
                    </AccordionItem>
                  </Card>
                )
              ) : null}

              {/* [Card-3]  Wallet History*/}
              <Card style={{ margin: '17pt auto' }} inner accordionList>
                <AccordionItem>
                  <CardHeader>
                    Wallet History
                    <AccordionToggle>
                      <Button outline iconF7="arrowtriangle_down_fill"></Button>
                    </AccordionToggle>
                  </CardHeader>

                  <AccordionContent>
                    <CardContent>
                      <List noHairlinesMd>
                        <ListItem title="Total transactions">
                          <small slot="after">
                            {this.props.transactions.length || '0'}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        <ListItem title="Total amount Received">
                          <small slot="after">
                            {this.props.transactions.length > 0
                              ? new Intl.NumberFormat('en-GB', {
                                  style: 'currency',
                                  currency: 'NGN',
                                }).format(
                                  this.props.transactions
                                    .filter(
                                      (t) =>
                                        t.type === 'Received' &&
                                        t.status === 'Success'
                                    )
                                    .map((t) => t.amount)
                                    .reduce((a, b) => +a + +b, 0)
                                )
                              : new Intl.NumberFormat('en-GB', {
                                  style: 'currency',
                                  currency: 'NGN',
                                }).format(0)}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        <ListItem title="Total amount withdrawn">
                          <small slot="after">
                            {this.props.transactions.length > 0
                              ? new Intl.NumberFormat('en-GB', {
                                  style: 'currency',
                                  currency: 'NGN',
                                }).format(
                                  this.props.transactions
                                    .filter((t) => t.type === 'Withdrawn')
                                    .map((t) => t.amount)
                                    .reduce((a, b) => Number(a) + Number(b), 0)
                                )
                              : new Intl.NumberFormat('en-GB', {
                                  style: 'currency',
                                  currency: 'NGN',
                                }).format(0)}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        {this.props.wallets &&
                          this.props.wallets[
                            this.props.merchants[this.props.auth.uid].walletId
                          ] && (
                            <ListItem title="Wallet balance">
                              <small slot="after">
                                {new Intl.NumberFormat('en-GB', {
                                  style: 'currency',
                                  currency: 'NGN',
                                }).format(
                                  Number(
                                    this.props.wallets[
                                      this.props.merchants[this.props.auth.uid]
                                        .walletId
                                    ].walletBalance
                                  )
                                )}
                              </small>
                              <Icon f7="number_square" slot="media" />
                            </ListItem>
                          )}
                      </List>
                    </CardContent>
                  </AccordionContent>
                </AccordionItem>
              </Card>
            </Col>

            <Col width="100">
              {/* [Card-4]  Transactions Details*/}
              <Card
                className="data-table data-table-init"
                style={{
                  width: '100%',
                  marginLeft: '0px',
                  margin: '2pt auto',
                  maxHeight: '700px',
                }}>
                <CardHeader>
                  <div className="data-table-title">Transactions</div>
                </CardHeader>
                {this.props.transactions.length > 0 ? (
                  <CardContent
                    padding={false}
                    style={{ maxHeight: '600px', overflow: 'scroll' }}>
                    <table className="sticky">
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th>
                            <span className="table-head-label">Wallet ID</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Transaction ID
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Order ID</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Transaction Amount
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Type</span>
                          </th>
                          <th>
                            <span className="table-head-label">Status</span>
                          </th>
                          <th>
                            <span className="table-head-label">Timestamp</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.transactions
                          .sort((a, b) => +b.timestamp - a.timestamp)
                          .map(
                            (
                              {
                                id,
                                walletId,
                                type,
                                amount,
                                timestamp,
                                status,
                                orderId,
                                orderAmount,
                              },
                              i
                            ) => (
                              <tr key={id}>
                                <td>{i + 1}</td>
                                <td>{walletId}</td>
                                <td>{id}</td>
                                <td>
                                  <div>{orderId ? orderId : '-'}</div>
                                </td>
                                <td
                                  style={{
                                    color:
                                      status === 'Success' &&
                                      type === 'Received'
                                        ? 'green'
                                        : 'red',
                                  }}>
                                  <div>
                                    {new Intl.NumberFormat('en-GB', {
                                      style: 'currency',
                                      currency: 'NGN',
                                    }).format(amount)}
                                  </div>
                                </td>
                                <td>
                                  {type === 'Received' && status === 'Failed'
                                    ? 'Declined'
                                    : type}
                                </td>
                                <td
                                  style={{
                                    color:
                                      status === 'Failed' ? 'red' : 'green',
                                  }}>
                                  {status}
                                </td>
                                <td>
                                  <div>{moment(timestamp).fromNow()}</div>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </CardContent>
                ) : (
                  <CardContent padding={false}>
                    <Block className="block-info">
                      <Row>
                        <Col>
                          <p>No transactions available at the moment</p>
                        </Col>
                      </Row>
                    </Block>
                  </CardContent>
                )}
              </Card>
            </Col>
          </Row>
        </Block>

        <Popup 
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: '', which: '' },
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}>
          <Page>
            <Navbar title="Editor">
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            <Block className="pattern-banner bg-color-jasmine">
              <Card style={{ width: '100%', margin: 0 }}>
                <CardHeader>
                  <h3 style={{ margin: 0 }}>{this.state.popupData.title}</h3>
                </CardHeader>
              </Card>
            </Block>

            {/* Content for add bank details */}
            {this.state.popupData.which == 'add-bank' ? (
              <Block>
                <Card style={{ margin: 'auto' }}>
                  <CardHeader>Account Details</CardHeader>
                  <CardContent>
                    <List noHairlinesMd form id="bank-editor">
                      {/* <ListInput
                        label="Bank account name"
                        type="text"
                        info="Account name is automated"
                        disabled={true}
                        value={this.state.bank.accountName}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              accountName: e.target.value,
                            },
                          })
                        }>
                        <Icon f7="briefcase" slot="media" />
                      </ListInput> */}

                      <ListInput
                        label="Bank account number"
                        type="number"
                        placeholder="eg: 0123456789"
                        info={
                          this.state.bank.accountName === ''
                            ? 'Bank account number is required'
                            : this.state.bank.accountName
                        }
                        required
                        validate
                        clearButton
                        value={this.state.bank.accountNumber}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              accountNumber: e.target.value,
                            },
                          })
                        }>
                        <Icon f7="creditcard_fill" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Bank name"
                        type="select"
                        name="bank"
                        style={{ paddingLeft: 0 }}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              bankName: e.target.value,
                              bankCode: this.state.banks.find(
                                (bank) => bank.name === e.target.value
                              ).code,
                            },
                          })
                        }>
                        <option></option>
                        {this.state.banks.map((bank) => (
                          <option key={bank.name} value={bank.name}>
                            {bank.name}
                          </option>
                        ))}

                        <Icon f7="building_2_fill" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Bank sort code"
                        type="text"
                        placeholder="Type sort code of account here"
                        info="Bank sort code is optional"
                        clearButton
                        value={this.state.bank.sortCode}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            bank: {
                              ...this.state.bank,
                              sortCode: e.target.value,
                            },
                          })
                        }>
                        <Icon f7="building_2_fill" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      disabled={
                        this.state.addBankButton !== 'Upload Bank Details'
                      }
                      style={{ width: '100%' }}
                      onClick={this.addBank.bind(this)}>
                      {this.state.addBankButton} &nbsp;{' '}
                      {this.state.addBankButton !== 'Upload Bank Details' && (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  componentDidMount() {
    // Auto update wallet name

    if (
      this.props.wallets &&
      this.props.merchants[this.props.auth.uid] &&
      this.props.wallets[this.props.merchants[this.props.auth.uid].walletId] &&
      !this.props.wallets[this.props.merchants[this.props.auth.uid].walletId]
        .name
    ) {
      this.props.firestore
        .collection('wallets')
        .doc(this.props.merchants[this.props.auth.uid].walletId)
        .update({
          name: this.props.merchants[this.props.auth.uid].businessProfile.name,
        })
        .catch((error) => {});
    }
  }

  // events
  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : 'admin';
    const previousView = args[0] ? args[0] : 'account';
    const previousPage = args[2] ? args[2] : 'account';

    self.$f7.views['message-master'].router.navigate(
      {
        name: 'message-master',
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      }
    );
  }

  withdrawalRetry(pw) {
    this.$f7.preloader.show();
    // make transfer
    const transferDetails = {
      amount: pw.amount,
      recipient: pw.recipient,
      reason: {
        walletId: pw.reason.walletId,
        email: pw.reason.email,
        commission: pw.reason.commission,
      },
      retry: {
        reference: pw.reference,
      },
    };

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        transferDetails.token = idToken;
        transferDetails.uid = this.props.auth.uid;

        // initiate transfer
        initiateATransfer(transferDetails, (error, data) => {
          if (error) {
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: error,
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }

          this.$f7.preloader.hide();
          return this.$f7.dialog.alert(
            'Processing transaction, you will recieve a mail shortly'
          );
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  initiateTransfer() {
    this.$f7.preloader.show();
    this.setState({
      ...this.state,
      withdrawalButton: '',
    });

    const walletBalance = this.props.wallets[
      this.props.merchants[this.props.auth.uid].walletId
    ].walletBalance;

    const pendingWithdrawal = this.props.wallets[
      this.props.merchants[this.props.auth.uid].walletId
    ].pendingWithdrawal
      ? this.props.wallets[
          this.props.merchants[this.props.auth.uid].walletId
        ].pendingWithdrawal
          .map((pw) => pw.amount / 100 + pw.reason.commission)
          .reduce((a, b) => a + b, 0)
      : 0;

    if (this.state.withdrawalInfo.recipientCode === '') {
      this.setState({
        ...this.state,
        withdrawalButton: 'Confirm Transaction',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Select a bank account',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (this.state.withdrawalInfo.amount < 1000) {
      this.setState({
        ...this.state,
        withdrawalButton: 'Confirm Transaction',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Mininmum withdrawal is NGN1,000',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (
      +this.state.withdrawalInfo.amount +
        +payStackTransferCharge(this.state.withdrawalInfo.amount) >
      +walletBalance - pendingWithdrawal
    ) {
      this.setState({
        ...this.state,
        withdrawalButton: 'Confirm Transaction',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Insufficient Balance',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    const bankAccount = this.props.wallets[
      this.props.merchants[this.props.auth.uid].walletId
    ].bankDetails.find(
      ({ recipientCode }) =>
        recipientCode === this.state.withdrawalInfo.recipientCode
    );
    this.$f7.preloader.hide();

    this.$f7.dialog.confirm(
      `
    <p><strong>Bank:</strong> ${bankAccount.bankName}</p>
    <p><strong>Account Name:</strong> ${bankAccount.accountName}</p>
    <p><strong>Account Number:</strong> ${bankAccount.accountNumber}</p>
    <p><strong>Amount:</strong> ${new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'NGN',
    }).format(+this.state.withdrawalInfo.amount)}</p>
    <p>You will be charged <strong>${new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'NGN',
    }).format(
      +payStackTransferCharge(this.state.withdrawalInfo.amount)
    )}</strong> for this transaction.</p>
    `,
      'Confirm Transaction',
      () => {
        // make transfer
        const transferDetails = {
          amount: `${+this.state.withdrawalInfo.amount * 100}`,
          recipient: this.state.withdrawalInfo.recipientCode,
          reason: {
            walletId: this.props.merchants[this.props.auth.uid].walletId,
            email: this.props.merchants[this.props.auth.uid].businessProfile
              .email,
            commission: +payStackTransferCharge(
              this.state.withdrawalInfo.amount
            ),
          },
        };
        this.$f7.preloader.show();

        this.props.firebase
          .auth()
          .currentUser.getIdToken(true)
          .then((idToken) => {
            transferDetails.token = idToken;
            transferDetails.uid = this.props.auth.uid;

            // send OTP to merchant's email
            sendOneTimePassword(
              { type: 'merchants', token: idToken, uid: this.props.auth.uid },
              (error, sent) => {
                if (error || !sent) {
                  this.setState({
                    ...this.state,
                    withdrawalButton: 'Confirm Transaction',
                  });
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: error,
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                }

                // open a dialog to confirm OTP
                this.$f7.preloader.hide();
                this.$f7.dialog
                  .create({
                    title: 'OTP CODE',
                    cssClass: 'otp-code-modal',
                    text:
                      'Confirm withdrawal by filling in the OTP code sent to your email address',
                    content: `<input class="dialog-input split-input" type="password" maxlength="4"/>`,
                    buttons: [
                      // button to resend otp
                      {
                        text: 'Resend Code',
                        color: 'gray',
                        cssClass: 'otp-resend',

                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          sendOneTimePassword(
                            {
                              type: 'merchants',
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, sent) => {
                              if (error || !sent) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: 'Confirm Transaction',
                                });

                                // if this error is a ban, close dialog
                                if (
                                  error ===
                                  'You cannot make a withdrawal at the moment. Please contact admin.'
                                ) {
                                  dialog.close();
                                }

                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: 'bottom',
                                  horizontalPosition: 'center',
                                  closeButton: true,
                                  cssClass: 'custom-toast',
                                  closeTimeout: 4000,
                                });
                              }

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: 'OTP code sent',
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }
                          );
                        },
                      },
                      // button to cancel
                      {
                        text: 'x',
                        color: 'white',
                        cssClass: 'otp-close',
                        onClick: (dialog, e) => {
                          this.setState({
                            ...this.state,
                            withdrawalButton: 'Confirm Transaction',
                          });
                          this.$f7.preloader.hide();
                        },
                      },
                      // button to continue
                      {
                        text: 'Continue',
                        bold: true,
                        cssClass: 'otp-continue',
                        keyCodes: [13],
                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          // password
                          const password = dialog.$el
                            .find('.dialog-input')
                            .val();

                          // Verify otp
                          verifyOneTimePassword(
                            {
                              password,
                              type: 'merchants',
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, success) => {
                              if (error || !success) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: 'Confirm Transaction',
                                });

                                // close if ban
                                if (
                                  error ===
                                  'You cannot make a withdrawal at the moment. Please contact admin.'
                                ) {
                                  dialog.close();
                                }

                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: 'bottom',
                                  horizontalPosition: 'center',
                                  closeButton: true,
                                  cssClass: 'custom-toast',
                                  closeTimeout: 4000,
                                });
                              }

                              // close dialog
                              dialog.close();

                              // initiate transfer
                              initiateATransfer(
                                transferDetails,
                                (error, data) => {
                                  if (error) {
                                    this.setState({
                                      ...this.state,
                                      withdrawalButton: 'Confirm Transaction',
                                    });
                                    this.$f7.preloader.hide();
                                    return toast(this.$f7.toast, {
                                      text: error,
                                      position: 'bottom',
                                      horizontalPosition: 'center',
                                      closeButton: true,
                                      cssClass: 'custom-toast',
                                      closeTimeout: 4000,
                                    });
                                  }

                                  this.setState({
                                    ...this.state,
                                    withdrawalButton: 'Confirm Transaction',
                                    withdrawalInfo: {
                                      ...this.state.withdrawalInfo,
                                      amount: 0,
                                    },
                                  });
                                  this.$f7.preloader.hide();
                                  return toast(this.$f7.toast, {
                                    text:
                                      'Processing transaction, you will recieve a mail shortly',
                                    position: 'bottom',
                                    horizontalPosition: 'center',
                                    closeButton: true,
                                    cssClass: 'custom-toast',
                                    closeTimeout: 4000,
                                  });
                                }
                              );
                            }
                          );
                        },
                      },
                    ],
                  })
                  .open();
              }
            );
          })
          .catch((error) => {
            this.setState({
              ...this.state,
              withdrawalButton: 'Confirm Transaction',
            });
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          });
      },
      () => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          withdrawalButton: 'Confirm Transaction',
        });
      }
    );
  }

  addBank() {
    this.$f7.preloader.show();
    this.setState({ ...this.state, addBankButton: '' });
    const bankDetails = {
      ...this.state.bank,
    };

    if (isEmpty(bankDetails.accountNumber)) {
      this.setState({ ...this.state, addBankButton: 'Upload Bank Details' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Account Number is required.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (isEmpty(bankDetails.bankName)) {
      this.setState({ ...this.state, addBankButton: 'Upload Bank Details' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Bank Name is required.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (this.state.BanksWithIssues.includes(bankDetails.bankName)) {
      this.setState({ ...this.state, addBankButton: 'Upload Bank Details' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "We have issue with this bank's API, please choose another bank.",
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        resolveAccountNumber(
          bankDetails.accountNumber,
          bankDetails.bankCode,
          idToken,
          this.props.auth.uid,
          (error, data) => {
            this.$f7.preloader.hide();
            if (error) {
              this.setState({
                ...this.state,
                addBankButton: 'Upload Bank Details',
              });
              return toast(this.$f7.toast, {
                text: error,
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }

            this.$f7.dialog.confirm(
              `Please confirm your account name: ${data.account_name}`,
              'Account Name',
              () => {
                this.setState({
                  ...this.state,
                  bank: {
                    ...this.state.bank,
                    accountName: data.account_name,
                  },
                });
                this.$f7.preloader.show();
                bankDetails.accountName = data.account_name;

                createTransferRecipient(
                  {
                    ...bankDetails,
                    token: idToken,
                    uid: this.props.auth.uid,
                    wallet: 'merchant',
                  },
                  (error, recipientCode) => {
                    if (error) {
                      this.setState({
                        ...this.state,
                        addBankButton: 'Upload Bank Details',
                      });
                      this.$f7.preloader.hide();
                      return toast(this.$f7.toast, {
                        text: 'Something went wrong. Try again.',
                        position: 'bottom',
                        horizontalPosition: 'center',
                        closeButton: true,
                        cssClass: 'custom-toast',
                        closeTimeout: 4000,
                      });
                    }

                    bankDetails.recipientCode = recipientCode;

                    if (this.props.wallets) {
                      // update
                      const walletId = Object.keys(this.props.wallets)[0];
                      const update = [
                        ...this.props.wallets[
                          this.props.merchants[this.props.auth.uid].walletId
                        ].bankDetails,
                        {
                          ...bankDetails,
                        },
                      ];

                      addOrRemoveBank(
                        walletId,
                        update,
                        idToken,
                        this.props.auth.uid,
                        (error, bankAdded) => {
                          if (error) {
                            this.setState({
                              ...this.state,
                              addBankButton: 'Upload Bank Details',
                            });
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: handleErrors(error),
                              position: 'bottom',
                              horizontalPosition: 'center',
                              closeButton: true,
                              cssClass: 'custom-toast',
                              closeTimeout: 4000,
                            });
                          }

                          this.setState({
                            ...this.state,
                            popupOpened: false,
                            addBankButton: 'Upload Bank Details',
                            bank: {
                              ...this.state.bank,
                              bankName: '',
                              accountName: '',
                              accountNumber: '',
                              sortCode: '',
                              bankCode: '',
                            },
                          });
                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: 'Bank Profile Uploaded',
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }
                      );
                    } else {
                      // new
                      const walletId = generateId(7);
                      const wallet = {
                        walletBalance: 0,
                        transactions: [],
                        bankDetails: [bankDetails],
                      };
                      this.props.firestore
                        .collection('merchants')
                        .doc(this.props.auth.uid)
                        .update({ walletId })
                        .then(() => {
                          addOrRemoveBank(
                            walletId,
                            wallet,
                            idToken,
                            this.props.auth.uid,
                            (error, bankAdded) => {
                              if (error) {
                                this.setState({
                                  ...this.state,
                                  addBankButton: 'Upload Bank Details',
                                });
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: handleErrors(error),
                                  position: 'bottom',
                                  horizontalPosition: 'center',
                                  closeButton: true,
                                  cssClass: 'custom-toast',
                                  closeTimeout: 4000,
                                });
                              }

                              this.setState({
                                ...this.state,
                                popupOpened: false,
                                addBankButton: 'Upload Bank Details',
                                bank: {
                                  ...this.state.bank,
                                  bankName: '',
                                  accountName: '',
                                  accountNumber: '',
                                  sortCode: '',
                                  bankCode: '',
                                },
                              });
                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: 'Bank Profile Uploaded',
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            }
                          );
                        })
                        .catch((error) => {
                          this.setState({
                            ...this.state,
                            addBankButton: 'Upload Bank Details',
                          });
                          return toast(this.$f7.toast, {
                            text: handleErrors(error),
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        });
                    }
                  }
                );
              },
              () => {
                this.setState({
                  ...this.state,
                  addBankButton: 'Upload Bank Details',
                });
              }
            );
          }
        );
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          addBankButton: 'Upload Bank Details',
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  deleteBank(index, recipientCode) {
    this.$f7.preloader.show();
    const walletId = this.props.merchants[this.props.auth.uid].walletId;
    const bankDetails = [...this.props.wallets[walletId].bankDetails];

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        deleteTransferRecipient(
          {
            recipientCode,
            token: idToken,
            uid: this.props.auth.uid,
            wallet: 'merchant',
          },
          (error, isDeleted) => {
            if (error) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text:
                  'Something went wrong. Cannot delete account, please try again',
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }

            bankDetails.splice(index, 1);

            addOrRemoveBank(
              walletId,
              bankDetails,
              idToken,
              this.props.auth.uid,
              (error, bankRemoved) => {
                if (error) {
                  this.$f7.preloader.hide();
                  toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                }

                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: 'Bank Profile Deleted',
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              }
            );
          }
        );
      });
  }
}

const mapStateToProps = ({
  firebase: { auth },
  DB: {
    docs: { loading, transactions },
  },
}) => ({
  auth,
  loadingDoc: loading,
  transactions: (transactions && transactions) || [],
});

const enhance = compose(
  withStorage,
  firestoreConnect((props) => [
    new Doc(
      'wallets',
      (props.merchants &&
        props.merchants !== null &&
        props.merchants[props.auth.uid] &&
        props.merchants[props.auth.uid].walletId &&
        props.merchants[props.auth.uid].walletId) ||
        null
    ),
    new DocArray(
      'transactions',
      (props.merchants &&
        props.merchants[props.auth.uid] &&
        props.merchants[props.auth.uid].walletId &&
        props.merchants[props.auth.uid].walletId) ||
        null,
      'walletId'
    ),
  ]),
  connect(mapStateToProps)
);

export default enhance(MerchantWallet);
